import Header from "../../../components/header/Header";
import WebDevHero from "../../../components/Technologies/DataEngineeringAnalytics/DataEngineeringHero/DataEngineeringHero";
import WebDevTech from "../../../components/Technologies/DataEngineeringAnalytics/DataEngineeringTech/DataEngineeringTech";
import WebDevExpertise from "../../../components/Technologies/DataEngineeringAnalytics/DataEngineeringExpertise/DataEngineeringExpertise";
import WebDevOutcomes from "../../../components/Technologies/DataEngineeringAnalytics/DataEngineeringOutcomes/DataEngineeringOutcomes";
import WebDevImpactCTA from "../../../components/Technologies/DataEngineeringAnalytics/DataEngineeringImpactCTA/DataEngineeringImpactCTA";
import Footer from "../../../components/Footer/Footer";
const DataEngineering = () => {
  return (
    <>
      <Header />
      <WebDevHero />
      <WebDevTech />
      <WebDevExpertise />
      <WebDevOutcomes />
      <WebDevImpactCTA />
      <Footer />
    </>
  );
};

export default DataEngineering;
